module.exports = __webpack_public_path__ + "img/yaoxing.d78c36d6.png";